<script setup lang="ts">
const route = useRoute()

const constructData = computed(() => {
  const services = [
    {
      key: 'reguler',
      subTitle:
        'Selain pengiriman reguler, KiriminAja juga menyediakan opsi pengiriman instant dan kargo<br />untuk memenuhi kebutuhanmu dengan lebih fleksibel.',
      name: 'Pengiriman Reguler',
      description:
        'Pengiriman reguler menyediakan banyak pilihan ekspedisi. Tersedia metode pembayaran COD dan non COD untuk memenuhi permintaan pelangganmu.',
      image: '/images/batch-2/card-regular.webp'
    },
    {
      key: 'instan',
      subTitle:
        'Selain pengiriman instant, KiriminAja juga menyediakan opsi pengiriman reguler dan kargo<br />untuk memenuhi kebutuhanmu dengan lebih fleksibel.',
      name: 'Pengiriman Instant',
      description:
        'Pengiriman instant memiliki estimasi sampai ke penerima dalam hitungan jam. Tersedia pilihan kendaraan motor dan mobil sesuai berat paket yang ingin dikirim.',
      image: '/images/batch-2/card-instant.webp'
    },
    {
      key: 'kargo',
      subTitle:
        'Selain pengiriman kargo, KiriminAja juga menyediakan opsi pengiriman reguler dan instant<br />untuk memenuhi kebutuhanmu dengan lebih fleksibel.',
      name: 'Pengiriman Kargo',
      description:
        'Untuk paket yang berat maupun berdimensi besar, cocok menggunakan pengiriman kargo. Ongkos kirim lebih hemat dan tetap aman sampai ke tujuan.',
      image: '/images/batch-2/card-cargo.webp'
    }
  ]

  return {
    subTitle:
      services.find((service) => route.path.includes(service.key))?.subTitle ||
      '',
    services: services.filter((service) => !route.path.includes(service.key))
  }
})
</script>

<template>
  <UiContainer class="flex flex-col gap-11 py-7 lg:py-12">
    <UiSectionTitle
      class="text-center"
      title="Pilihan Pengiriman Lainnya"
      :description="constructData.subTitle"
    />
    <div
      class="w-full lg:max-w-10/12 mx-auto flex gap-5 justify-center items-stretch flex-wrap"
    >
      <UiCardLink
        v-for="(service, index) in constructData.services"
        :key="index"
        :title="service.name"
        :description="service.description"
        :link-label="'Tentang ' + service.name"
        :image-url="service.image"
        :to="'/layanan/' + service.key"
      />
    </div>
  </UiContainer>
</template>
